export default __webpack_public_path__ + "static/media/logo_bdemr.58847ace.png";